import { faker } from '@faker-js/faker'
import { DateTime } from 'luxon'
import { get } from 'svelte/store'

import { role$ } from '../store'

import SwitchCheckbox from '../components/googleForm/SwitchCheckbox.svelte'
import TextInput from '../components/firestore/inputs/TextInput.svelte'
import PhoneInput from '../components/firestore/inputs/PhoneInput.svelte'
import NumberInput from '../components/firestore/inputs/NumberInput.svelte'
import ComboInput from '../components/firestore/inputs/ComboInput.svelte'
import RadioSelect from '../components/firestore/inputs/RadioSelect.svelte'

faker.locale = 'ja'

// ダミー生成関数
const lottery = array => () => faker.helpers.arrayElement(array)
const serverTimestamp = () => ({
  seconds: faker.datatype.number(),
  nanoseconds: faker.datatype.number(),
})
const YYYY_MM_DD = () =>
  DateTime.fromJSDate(faker.date.past()).toFormat('yyyy-MM-dd')
const range =
  ({ min, max, precision }) =>
  () =>
    faker.datatype.number({ min, max, precision })
const etcUsage = () =>
  !range({ min: 0, max: 4 })()
    ? [faker.address.city(), faker.address.city()].join('-')
    : null
const memo = () => (!range({ min: 0, max: 4 })() ? faker.lorem.words() : null)
const fee = () => faker.datatype.number({ min: 35, max: 45 }) * 1000
const fakeMemberList = () =>
  Array.from({ length: 10 }, () => faker.name.fullName)
const fakeProjectCode = () =>
  faker.datatype.number({ min: 25, max: 75 }) +
  '-' +
  faker.datatype.number({ min: 700, max: 2500 })
const fakeYokotaLogHours = () => [] // TODO:

export const DRIVE_REPORT_SCHEME = [
  {
    name: 'createAt',
    label: '作成日',
    uneditable: true,
    faker: serverTimestamp,
  },
  {
    name: 'date',
    label: '日付',
    uneditable: true,
    faker: YYYY_MM_DD,
  },
  {
    name: 'reporterName',
    label: '報告者名',
    uneditable: true,
    faker: faker.name.lastName,
  },
  {
    name: 'weather',
    label: '天気',
    editor: { component: RadioSelect, props: { options: ['晴', '曇', '雨'] } },
    faker: lottery(['晴', '曇', '雨']),
  },

  {
    name: 'carNumber',
    label: '車両番号',
    editor: {
      component: RadioSelect,
      props: { options: ['姫路131き17(三菱)', '姫路130い129(日野)'] },
    },
    faker: faker.datatype.number,
  },
  {
    name: 'odometerStart',
    label: 'メーター始',
    editor: { component: NumberInput },
    faker: faker.datatype.number,
  },
  {
    name: 'odometerEnd',
    label: 'メーター終',
    editor: { component: NumberInput },
    faker: faker.datatype.number,
  },
  {
    name: 'refuel',
    label: '給油量',
    editor: { component: NumberInput },
    faker: faker.datatype.number,
  },
  {
    name: 'odometerOil',
    label: 'オイル交換時メーター',
    editor: { component: NumberInput },
    faker: faker.datatype.number,
  },

  {
    name: 'memo',
    label: 'メモ',
    editor: { component: TextInput },
    faker: memo,
  },
]

export const ROUTE_LOG_SCHEME = [
  {
    name: 'createAt',
    label: '作成日',
    uneditable: true,
    faker: serverTimestamp,
  },
  {
    name: 'date',
    label: '日付',
    uneditable: true,
    faker: YYYY_MM_DD,
  },
  {
    name: 'reporterName',
    label: '報告者名',
    uneditable: true,
    faker: faker.name.lastName,
  },
  {
    name: 'order',
    label: '並び順',
    uneditable: true,
    faker: faker.date.past,
  },
  {
    name: 'client',
    label: '顧客名',
    editor: {
      component: ComboInput,
      props: { options: ['石本建設', '三光興業', '暖真建設', '沼本興業'] },
    },
    faker: faker.company.companyName,
  },
  {
    name: 'origin',
    label: '自',
    editor: { component: TextInput },
    faker: faker.address.streetName,
  },
  {
    name: 'destination',
    label: '至',
    editor: { component: TextInput },
    faker: faker.address.streetName,
  },
  {
    name: 'distance',
    label: '距離',
    editor: { component: NumberInput },
    faker: faker.datatype.number,
  },
  {
    name: 'etcUsage',
    label: 'ETC区間',
    editor: { component: TextInput },
    faker: etcUsage,
  },
  {
    name: 'etcPrice',
    label: 'ETC単価',
    editor: { component: NumberInput },
    faker: range({ min: 160, max: 800 }),
  },
  {
    name: 'etcTimes',
    label: 'ETC回数',
    editor: { component: NumberInput },
    faker: range({ min: 1, max: 9 }),
  },
  {
    name: 'item',
    label: '品名',
    editor: {
      component: ComboInput,
      props: { options: ['リサイクル', '土砂', 'ガラ', 'クラッシャーラン'] },
    },
    faker: faker.commerce.productName,
  },
  {
    name: 'times',
    label: '回数',
    editor: { component: NumberInput },
    faker: range({ min: 1, max: 5 }),
  },
  {
    name: 'contractor',
    label: '傭車名',
    editor: {
      component: ComboInput,
      props: { options: ['自社', 'サンキテック', '福田商店', '尾西興業'] },
    },
    faker: faker.company.companyName,
  },
  {
    name: 'carNumber',
    label: '車両番号',
    editor: {
      component: ComboInput,
      props: { options: ['17', '129', '1818'] },
    },
    faker: faker.datatype.number,
  },
  {
    name: 'driverName',
    label: '運転者名',
    editor: { component: ComboInput, props: { options: ['西脇', '長郷'] } },
    faker: faker.name.lastName,
  },
  {
    name: 'memo',
    label: 'メモ',
    editor: { component: TextInput },
    hideEmpty: true,
    faker: memo,
  },
  {
    name: 'charge',
    label: '請求単価',
    editor: { component: NumberInput },
    isSecret: true,
    faker: fee,
  },
  {
    name: 'payment',
    label: '支払単価',
    editor: { component: NumberInput },
    isSecret: true,
    faker: fee,
  },
]

export const YOKOTA_REPORT_SCHEME = [
  {
    name: 'createAt',
    label: '作成日',
    uneditable: true,
    faker: serverTimestamp,
  },
  {
    name: 'date',
    label: '日付',
    uneditable: true,
    faker: YYYY_MM_DD,
  },
  {
    name: 'memberList',
    label: 'メンバー',
    uneditable: true,
    faker: fakeMemberList,
  },
  {
    name: 'reporterName',
    label: '報告者名',
    editor: { component: ComboInput, props: { options: ['西脇', '長郷'] } },
    faker: faker.name.lastName,
  },
  {
    name: 'memo',
    label: 'メモ',
    editor: { component: TextInput },
    faker: memo,
  },
]

export const YOKOTA_LOG_SCHEME = [
  {
    name: 'projectCode',
    label: '工番',
    type: 'phone', // 数字とハイフンのみ許可
    editor: { component: PhoneInput },
    faker: fakeProjectCode,
  },
  {
    name: 'supervisorName',
    label: '監督',
    type: 'text',
    editor: {
      component: ComboInput,
      props: { options: ['三浦', '泉', '斎藤', '吉田', '崎田'] },
    },
    faker: faker.name.lastName,
  },
  {
    name: 'task',
    label: '作業内容',
    type: 'text',
    editor: {
      component: ComboInput,
      props: {
        columnSize: 'narrow',
        options: ['KL', 'モノマー', '油脂', '塩ビ', '動力', '三菱', '特樹'],
      },
    },
    faker: faker.commerce.productName,
  },
  {
    name: 'isOvertime',
    label: '残業',
    type: 'checkbox',
    editor: {
      component: SwitchCheckbox,
      props: {
        label: '',
        description: '残業',
        required: false,
      },
    },
    faker: faker.datatype.boolean,
  },
  {
    name: 'hours',
    label: '作業時間',
    // type: 'other',
    faker: fakeYokotaLogHours,
  },
]

export const ALL_SCHEMES = [
  DRIVE_REPORT_SCHEME,
  ROUTE_LOG_SCHEME,
  YOKOTA_REPORT_SCHEME,
  YOKOTA_LOG_SCHEME,
]

/**
 * スキーマに対応するフェイク データを作成する
 * @param {object} scheme 対象スキーマ
 * @returns フェイク データ
 */
export const generateFake = scheme =>
  Object.fromEntries(
    scheme.map(field => [field.name, field.faker()]).filter(pair => pair[1])
  )

// 自分に閲覧する権限があるか否か
const isPermitted = field => get(role$) || !field.isSecret

/**
 * スキーマ定義から自分に権限があるフィールドだけを抽出する
 * @param {Array<Field>} scheme スキーマ定義
 * @returns {Array<Field>} 権限があるフィールドの配列
 */
export const filterPermittedFields = scheme =>
  scheme.filter(field => !field.uneditable && isPermitted(field))
